"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertBannerNeoDark = exports.alertBannerNeoLight = exports.alertBannerNovoDark = exports.alertBannerNovo = exports.alertBanner = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const alertBanner = {
    background: light.warning01,
    color: light.textColor07,
    iconColor: light.icon08,
};
exports.alertBanner = alertBanner;
const alertBannerNovo = alertBanner;
exports.alertBannerNovo = alertBannerNovo;
const alertBannerNovoDark = {
    background: dark.warning01,
    color: dark.textColor07,
    iconColor: dark.icon08,
};
exports.alertBannerNovoDark = alertBannerNovoDark;
const alertBannerNeoLight = {
    ...alertBannerNovo,
    background: neoLight.warning01,
    color: neoLight.textColor07,
    iconColor: neoLight.icon08,
};
exports.alertBannerNeoLight = alertBannerNeoLight;
const alertBannerNeoDark = {
    ...alertBannerNovoDark,
    background: neoDark.warning01,
    color: neoDark.textColor07,
    iconColor: neoDark.icon08,
};
exports.alertBannerNeoDark = alertBannerNeoDark;
